import type { SVGProps } from "react";

const IconRadioCheck = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#22F5EE" />
      <path
        d="M8.69891 13.9113C8.47753 13.9113 8.25703 13.8264 8.08816 13.6575L4.63278 10.1881C4.29591 9.8495 4.29591 9.3 4.63278 8.96138C4.97053 8.62275 5.51741 8.62275 5.85428 8.96138L8.69891 11.8174L14.1344 6.36C14.4713 6.0205 15.0182 6.0205 15.3559 6.36C15.6928 6.69863 15.6928 7.24725 15.3559 7.58588L9.30966 13.6575C9.14078 13.8264 8.91941 13.9113 8.69891 13.9113Z"
        fill="#17215C"
      />
    </svg>
  );
};

export default IconRadioCheck;
